/**
 *
 * Mixin
 *
 */

export const ExerciseMixin = {
  name: 'ExerciseMixin',

  props: {
    Question: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    c_isQuestionXL() {
      return 'xl' === this.Question.qType;
    },

    c_Question() {
      if (this.c_isQuestionXL) {
        return this.Question.subQuestions[this.Question.pos];
      } else {
        return this.Question;
      }
    },

    c_QuestionId() {
      return this.c_Question.questionId;
    },
  },
};
